/**
 *  关于 api 枚举
 */
export enum EnumApiAbout {
  /** 文章列表 */
  AboutList = '/core/api/articles',
  /** 文章阅读量增加 */
  AboutViewAdd = '/core/api/articles/{id}/view'
}
